export const environment = {
  production: true,
  supabaseClientConfig: {
    supabaseUrl: 'https://fvatqhsxamnvoljvteox.supabase.co',
    supabaseKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZ2YXRxaHN4YW1udm9sanZ0ZW94Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2NjQ3ODI5NTgsImV4cCI6MTk4MDM1ODk1OH0.L5awQFMVlUKDPblUee9TxiX2u7657GQjpFKwveW5oBc',
  },
  googleMapsApiKey: 'AIzaSyAtfajfr-AAwEQ_d-8nBi7cy5-uTIZ2f4Q',
  googleRedirectUrl: 'app.quickdrive.ch',
  appleRedirectUrl: 'https://app.quickdrive.ch/apple-callback',
  microsoftRedirectUrl: 'https://app.quickdrive.ch/microsoft-callback',
  passwordResetRedirectUrl: 'https://app.quickdrive.ch/reset-password',
  revenueCat: {
    ios: 'appl_WQvQVxCIkawmkijMAkVFwrDGjha',
    android: 'goog_vIZZAlaeENqjuHIuxXkgcrjaPqn',
    web: 'rcb_OoQMDhvLNyfLDgiADiNthEMhsIRI',
  },
  socialLogin: {
    ios: {
      google: '540703456253-ggpdh8ibvmt4mqttvnspcpu63h2u82qg.apps.googleusercontent.com',
    },
    android: {
      google: '540703456253-b601b67fv76o3tqvskoif2uctvbrekgc.apps.googleusercontent.com',
    }
  },
  bugsnagApiKey: '329ade7356939a86245ece49a40504d9',
};
